import { combineReducers } from 'redux'
import {
  loading, error, warning, ok, search, servername, clientid, copy, modalBrand, setMenuItem, selectedClient,
  reset, user, add,
} from './app.reducers'
import { tags, tag } from './tags.reducers'
import {
  affiliates,
  affiliate,
  network,
  check,
  selectAffiliate,
  categoriesAffiliates,
  selectAffiliateData,
  searchAffiliate,
  affiliatesSearch,
  affiliatesTotal,
} from './affiliates.reducers'
import { providers } from './providers.reducers'

import {
  products, product, saveProduct, selectProduct, categories,
} from './products.reducers'
import productCatalogReducer from './products-catalog.reducers'
import { bearer, userinfo, clients } from './auth.reducers'
import { setTokenResetPassword, passwordChanged } from './forgot_password.reducers'
import brokenLinks from './broken-links.reducers'

const appReducer = combineReducers({
  add,
  affiliate,
  affiliates,
  affiliatesTotal,
  affiliatesSearch,
  bearer,
  categories,
  categoriesAffiliates,
  check,
  clients,
  copy,
  error,
  warning,
  loading,
  menuItemSelected: setMenuItem,
  modalBrand,
  network,
  ok,
  passwordChanged,
  product,
  products,
  productCatalog: productCatalogReducer,
  providers,
  reset,
  saveProduct,
  search,
  searchAffiliate,
  selectAffiliate,
  selectAffiliateData,
  selectProduct,
  servername,
  clientid,
  selectedClient,
  tag,
  tags,
  tokenResetPassword: setTokenResetPassword,
  user,
  userInfo: userinfo,
  brokenLinks,
})

const rootReducer = (state, action) => {
  // when a logout action is dispatched it will reset redux state
  if (action.type === 'USER_LOGGED_OUT') {
    state = undefined
  }
  return appReducer(state, action)
}

export default rootReducer
